import * as THREE from "three";

/** Fits depth as well as height: a tank's front armor projects lower than its floor-level center. */
export function fitWorkshopCamera(
  camera: THREE.PerspectiveCamera,
  bounds: THREE.Box3,
  targetHeight: number,
): void {
  const target = new THREE.Vector3(0, targetHeight, 0);
  const outward = new THREE.Vector3(0, 0.27, 1).normalize();
  const up = new THREE.Vector3(0, outward.z, -outward.y);
  const tanY = Math.tan(THREE.MathUtils.degToRad(camera.fov / 2));
  const tanX = tanY * camera.aspect;
  const fill = 0.88;
  // Keep enough of the fabrication deck in view for the warm workshop setting.
  let distance = 1.47 / (tanX * fill);
  for (const x of [bounds.min.x, bounds.max.x]) {
    for (const y of [bounds.min.y, bounds.max.y]) {
      for (const z of [bounds.min.z, bounds.max.z]) {
        const point = new THREE.Vector3(x, y, z).sub(target);
        const depth = point.dot(outward);
        distance = Math.max(
          distance,
          depth + Math.abs(point.x) / (tanX * fill),
          depth + Math.abs(point.dot(up)) / (tanY * fill),
        );
      }
    }
  }
  camera.position.copy(target).addScaledVector(outward, distance);
  camera.lookAt(target);
  camera.updateMatrixWorld(true);
  camera.updateProjectionMatrix();
}
